import { render, staticRenderFns } from "./HistoryHot.vue?vue&type=template&id=208ad42c&scoped=true&"
import script from "./HistoryHot.vue?vue&type=script&lang=js&"
export * from "./HistoryHot.vue?vue&type=script&lang=js&"
import style0 from "./HistoryHot.vue?vue&type=style&index=0&id=208ad42c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ad42c",
  null
  
)

export default component.exports